/**
 * 첨부 목록의 모양 — 문서(PPTX·DOCX)와 그 문서에서 꺼낸 그림(parentId)을 가른다. 순수 함수(패널의 첨부 줄 · 사례 등록 화면).
 *
 * 꺼낸 그림은 목록(상태)에는 그대로 둔다 — 그 id 가 문서와 함께 AI 로 가야 캡처로 붙은 쿼리·실행계획을 읽는다.
 * 다만 **칩으로는 세우지 않는다**: 파일 하나를 붙였는데 여러 개로 갈라져 보이면 무엇을 붙였는지 헷갈린다(신고 2026-10-13).
 */

/** 칩으로 보일 것 — 부모가 목록에 있는 그림은 뺀다(부모가 없으면 홀로 선 첨부로 본다) */
export function topSources(sources) {
  const list = sources || [];
  const ids = new Set(list.map(s => s && s.id).filter(Boolean));
  return list.filter(s => s && !(s.parentId && ids.has(s.parentId)));
}

/** 그 문서에서 꺼낸 그림 수 */
export function childCount(sources, id) {
  if (!id) return 0;
  return (sources || []).filter(s => s && s.parentId === id).length;
}
